'use client';

import { Badge } from '@packages/shared/src/ui/Badge/Badge';

import { SlotEquivalentLinksItem } from '../Base/SlotEquivalentLinks.Item.client';
import { useWishlistLink } from '../../shared/useWishlistLink';

export const WishlistLink = () => {
  const { href, label, badgeCount } = useWishlistLink();

  const icon = <span className="icon-emp-wishlist size-4" aria-hidden />;

  return (
    <SlotEquivalentLinksItem href={href}>
      {badgeCount ? <Badge badgeContent={badgeCount}>{icon}</Badge> : icon}
      <span className="hyphens-auto">{label}</span>
    </SlotEquivalentLinksItem>
  );
};
